import { render, staticRenderFns } from "./LinksAdmin.vue?vue&type=template&id=b65eb2e2"
import script from "./LinksAdmin.vue?vue&type=script&lang=js"
export * from "./LinksAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports